import { createContext } from "@acng/frontend-relativity";
import { CTX_PROVIDE, CTX_VALUE } from "@acng/frontend-relativity/minify";
import { hasAttribute } from "@acng/frontend-bounty";
import { query } from "@acng/frontend-bounty/dom/query.js";
import { PopupController } from "./controller.js";
/**
 * Use that {@link Context} to provide a {@link PopupController}.
 *
 * @type {import("@acng/frontend-relativity").Context<PopupController>}
 */
const popupContext = createContext();
/**
 * Get the {@link PopupController} in the current {@link popupContext}.
 *
 * @param {Element} [consumer]
 * If `consumer` is not specified, the {@link globalPopupController} is returned.
 *
 * @throws {Error}
 * If the `target` is not connected to the `document`.
 *
 * @example
 * // local popup
 * popup(document.querySelector('article#123')).info('Article has been sold.');
 * // global popup
 * popup().error('Something went wrong.');
 * // or something more sophisticated
 * await popup().show(await loadHTMLElement());
 * popup().info('Previous popup has been closed.');
 */
export function popup(consumer) {
    if (consumer) {
        return popupContext[CTX_VALUE](consumer);
    }
    else {
        return globalPopupController;
    }
}
/**
 * Will be the Α and the Ω - father to all popup observers.
 *
 * @private
 */
export const globalPopupController = new PopupController(null);
// provide that globally
popupContext[CTX_PROVIDE](null, globalPopupController);
/**
 * @param {Element} element
 * @param {string} [containerSelectors]
 */
export const providePopupController = (element, containerSelectors) => {
    DEBUG: if (hasAttribute(element, "debug"))
        console.debug("discovery/popup/element connect", element);
    containerSelectors ||= ".template-popup, [data-popup-target]";
    popupContext[CTX_PROVIDE](element, new PopupController(query(element, containerSelectors) ?? element));
};
